import React, { Component } from 'react';
import '../css_generales/getContenedorFacturacion.css';
import GetCRubros from './getCRubros';
import GetItemsv2 from './getItemv2';
import GetCItems from './getCItems';
import GetCNota from './getCNota';
import GetCombo from './getCombo';
import GetCMenu from './getCMenu';
import GetCCliente from './getCCliente';
import { v4 as uuidv4 } from 'uuid';
import { confirmAlert } from 'react-confirm-alert';
class getContenedorFacturacion extends Component {
  constructor(props){
    super(props);
    this.state = {
      numero:this.props.numero,
      id_cliente : 0 ,
      sw_llevar:false,
      sw_cubiertos:false,
      observacion:'',
      id_rubro : 0,
      rubros : [],
      items : [],
      lista_items :[{"Crubro":"Productos", "Cidrubro":"0" ,
                    "Cuuidimagenrubro":"",
                    "Citems":[]}],
      items_cantidad :[],
      lista_items_adicional :[],
      total_items:0,
      total_precio:0,
      total_final:0,
      valor_pago_efectivo:0,
      costo_delivery:0,
      sub_modulo_modal : '',
      id_producto_combo:0,
      uuid_transaccion:'',
      id_index:-1,
      precio_combo:0,
      sw_iva:0,
      token_Client:'',
      msg_loading:false,
      id_forma_pago : 0,
      forma_pago :"Seleccionar Pago",
      razon_social :"CONSUMIDOR FINAL",
      ruc:"9999999999999",
      telefono:"S/N",
      direccion:"S/N",
      email:"S/N",
      id_datos_facturacion:0,
      alias:"Seleccionar Alias",
      ubicacion:'Seleccionar Ubicación',
      nombre:'',
      id_ubicacion:0,
      lat:0,lon:0,
      referencia_entrega:'',
      items_observaciones:[],
      id_sucursal:0,
      sucursales:[],
      total_kilometros:0,
      disabled:false,
      id_sub_puntoventa_pantalla:0,
      ok_item:false,
      horario:'',
      bd_base:'',
      sucursales_alternativas:[],
      showCambioSucursal:false,
      sucursal_alternativa_seleccionada:0,
      motivo_cambio:'',
      quien_solicita:'',
      enviando_cambio:false,
      password_cambio_sucursal: '',
      descuento:0
    }
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }
  getSucursales = async () => {
  try {
    const url = this.props.dir_url + "webapp/getSucursales";
    const token = this.props.token;

    const obj = { accion: 'sucursaldata', token };

    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!res.ok) {
      throw new Error("Error en la respuesta del servidor");
    }

    const data = await res.json();

    if (!data || !data[0]) {
      throw new Error("Respuesta inesperada del servidor");
    }

    if (data[0].status === "ok") {
      const sucursal = data[0].msg[0];

      // si la base es bd_app_lcr
      if (sucursal.base === "bd_app_lcr") {
        this.setState({
          sucursales: data[0].msg,
          id_sucursal: 0,
          disabled: true,
          bd_base: sucursal.base
        });
      } else {
        this.setState({
          sucursales: data[0].msg,
          id_sucursal: sucursal.id_sucursales,
          bd_base: sucursal.base
        });
      }
    }

  } catch (error) {
    console.error("Error obteniendo sucursales:", error);
  }
};
  getRubros =()=>{
    if(this.state.bd_base==='bd_app_lcr')return;
    const url= this.props.dir_url + "webapp/getDataRubroC";
    const token =  this.props.token
    var obj = { accion:'datarubroc', token };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        const id_rubro = data[0].msg[0].id_rubro
        this.setState({
          id_rubro,
          rubros :data[0].msg
        },()=>{
          this.getItems(id_rubro)
        })
      }
    })
    .catch(console.log)
  }
  getRegresar =()=>{
    this.setState({
      sub_modulo_modal:''
    })
  }
  getItems=(id_rubro)=>{
    const url= this.props.dir_url + "webapp/getDataItem";
    const token =  this.props.token
    const tipo = 1
    var obj = { accion:'dataitem', token ,id_rubro,tipo};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          items :data[0].msg
        })
      }else{
        this.setState({
          items : []
        })
      }
    })
    .catch(console.log)
  }

  get_List_Cliente =()=>{
    const url= this.props.dir_url + "webapp/getDataClient";
    const token =  this.props.token
    const token_Client =  this.state.token_Client
    var obj = { accion:'datacliente', token, token_Client};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          id_forma_pago:data[0].msg[0].id_forma_pago,
          forma_pago:data[0].msg[0].forma_pago,
          id_datos_facturacion:data[0].msg[0].id_datos_facturacion,
          razon_social:data[0].msg[0].razon_social,
          ruc:data[0].msg[0].ruc,
          telefono:data[0].msg[0].telefono,
          direccion:data[0].msg[0].direccion,
          email:data[0].msg[0].correo_electronico,
          alias:data[0].msg[0].alias
        })
      }
    })
    .catch(console.log)
  }

  additemv2 = (id_sub_puntoventa_pantalla,activo,id_item, item, precio_venta, iva, servicio, sw_incluido, id_rubro, id_subrubro, pfinal,id_combo,carga_maxima,uuid_imagen,descripcion) => {
    if(Number(this.state.id_sucursal)===0)return
    if(Number(activo)===1){
      if(Number(id_item)>0){
        // this.recuperar_item(id_item, item, precio_venta, iva, servicio, sw_incluido, id_rubro, id_subrubro, pfinal,id_combo,carga_maxima,0)
        this.additem(id_item, item, pfinal,descripcion,uuid_imagen,id_combo,1)
      }
      if(Number(id_sub_puntoventa_pantalla)>0){

        this.setState(
          {
             ok_item : false
          } , () => {
            this.consultarItemAPIV2(id_sub_puntoventa_pantalla,0);
          }
        )

      }
    }
  }
  /* const nuevoItems = { ...items_cantidad };
  nuevoItems["16a1541b-abed-4b27-83dc-f1107fe310ae"] = 0;
  setItemsCantidad(nuevoItems);
*/
  additem =(id_producto,producto,precio_venta,descripcion,uuid_imagen,combo,sw_iva)=>{
    //console.log(precio_venta)
    let uuid_transaccion = ""+uuidv4()
    //console.log( this.state.items_cantidad)
    if(Number(combo)===1){
      let lista_items = this.state.lista_items
      let items_cantidad = this.state.items_cantidad
      if(isNaN(items_cantidad[uuid_transaccion])){//if(isNaN(items_cantidad[id_producto])){
        items_cantidad[uuid_transaccion] = 0//items_cantidad[id_producto] = 0
        lista_items[0].Citems=[
          ...lista_items[0].Citems,{"id": id_producto,"component":producto,"precio_venta":precio_venta
          ,"descripcion":descripcion,"uuid_imagen":uuid_imagen,"combo":combo,"sw_iva":sw_iva,"uuid_transaccion":uuid_transaccion}
        ]
      }else{
        items_cantidad[uuid_transaccion] = 0//items_cantidad[id_producto] = 0
      }
      this.setState({
        uuid_transaccion:uuid_transaccion,
        id_producto_combo:id_producto,
        sub_modulo_modal:'combo',
        id_index:-1,
        precio_combo:precio_venta,
        sw_iva,
        lista_items,items_cantidad
      },()=>{
        this.total_pedido()
      })

    }else{
      let lista_items = this.state.lista_items
      let items_cantidad = this.state.items_cantidad
      const to4 = (v) => Number(parseFloat(v).toFixed(4));
      if(lista_items.length !== 0){
        lista_items.forEach(rubro => {
          rubro.Citems.forEach(item => {
            if(Number(item.combo)==0&&Number(item.id)==Number(id_producto)&&to4(item.precio_venta)===to4(precio_venta)){
              uuid_transaccion=item.uuid_transaccion
            }
          })
        })
      }
      
      if(isNaN(items_cantidad[uuid_transaccion])){//if(isNaN(items_cantidad[id_producto])){
        items_cantidad[uuid_transaccion] = 1//items_cantidad[id_producto] = 1
        lista_items[0].Citems=[
          ...lista_items[0].Citems,{"id": id_producto,"component":producto,"precio_venta":precio_venta
          ,"descripcion":descripcion,"uuid_imagen":uuid_imagen,"combo":combo,"sw_iva":sw_iva,"uuid_transaccion":uuid_transaccion}
        ]
      }else{
        items_cantidad[uuid_transaccion] = Number(items_cantidad[uuid_transaccion])+1
      }
      this.setState({
        lista_items,items_cantidad
      },()=>{
        this.total_pedido()
      })
    }
  }
  agregarPreferencias =(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial,uuid_transaccion)=>{
    this.setState({
      id_producto_combo:0,
      sub_modulo_modal:'',
      id_index:-1,
      precio_combo:0,
      sw_iva:0,
      uuid_transaccion:''
    },()=>{
      this.props_set_preferencias(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial,uuid_transaccion)
    })
  }

  props_set_preferencias=(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial,uuid_transaccion)=>{
    let lista_items_adicional = this.state.lista_items_adicional
    let lista_items_adicional_temp =[]
    lista_items_adicional.forEach((cp,index) => {
      if(uuid_transaccion!=cp.uuid_transaccion){ //if(Number(id_index)!==Number(index)){
        lista_items_adicional_temp=[
          ...lista_items_adicional_temp,{
            'complemento_final': cp.complemento_final,
            'id_producto_combo': cp.id_producto_combo,
            'precio_adicional': cp.precio_adicional,
            'sw_iva': cp.sw_iva,
            'precio_inicial': cp.precio_inicial,
            'uuid_transaccion': cp.uuid_transaccion,
          }
        ]
      }
    })
    lista_items_adicional=[
      ...lista_items_adicional_temp,{
        complemento_final,id_producto_combo,precio_adicional,sw_iva,precio_inicial,uuid_transaccion
      }
    ]
    this.setState({
      lista_items_adicional
    },()=>{
      this.total_pedido()
    })
  }

  props_set_cantidad =(items_cantidad)=>{
    this.setState(
      {items_cantidad}, ()=>{this.total_pedido()}
    );
  }
  total_pedido =()=>{
    const roundTo = require('round-to');
    const lista_items = this.state.lista_items
    const lista_items_adicional = this.state.lista_items_adicional
    const items_cantidad = this.state.items_cantidad
    let costo_delivery = this.state.costo_delivery
    const sw_llevar = this.state.sw_llevar
    if(sw_llevar){
      costo_delivery=0
    }
    let total_precio = 0
    let total_items  = 0
    let total_final = 0



    if(lista_items.length !== 0){
      lista_items.forEach(rubro => {
        rubro.Citems.forEach(item => {

          if(isNaN(items_cantidad[item.uuid_transaccion])){//if(isNaN(items_cantidad[item.id])){
            //cantidad_item = cantidad_item + 1;
          }else{
            total_items = total_items + Number(items_cantidad[item.uuid_transaccion]);//total_items = total_items + Number(items_cantidad[item.id]);
            total_precio = total_precio + roundTo(Number(item.precio_venta)*Number(items_cantidad[item.uuid_transaccion]) ,2)//total_precio = total_precio +roundTo(Number(item.precio_venta)*Number(items_cantidad[item.id]) ,2)
          }
        })
        //
      })
    }
    console.log(lista_items_adicional)
    if(lista_items_adicional.length !== 0){
      lista_items_adicional.forEach(lista_items_adicional => {
            total_items = total_items + 1;
            //total_precio = total_precio +roundTo(Number(lista_items_adicional.precio_adicional),2)
            total_precio = total_precio +roundTo(Number(lista_items_adicional.precio_inicial)+Number(lista_items_adicional.precio_adicional),2)
      })
    }
    const hoy = new Date().getDay(); 
    let descuento=0
    console.log("dia"+hoy)
    if(!sw_llevar){
      /*if((hoy === 1 || hoy === 3) && Number(total_precio) >=25){
        descuento = 2.50
        //costo_delivery = costo_delivery  -descuento;
      }*/
    }
    total_precio=roundTo(total_precio,2);
    total_final=roundTo(total_precio+Number(costo_delivery)-Number(descuento),2)
    this.setState({
      total_items,total_precio,total_final,descuento
    })
  }
  get_opcion_no =()=>{

  }
  get_go_to=(opcion)=>{
    if(opcion==='finalizar_pedido'){
      confirmAlert({
        title: 'Enviar Pedido',
        message: '¿Desea Enviar Pedido?',
        buttons: [
          {
            label: 'Sí',
            onClick: () => this.get_finalizar_pedido(0)
          },
          {
            label: 'No',
            onClick: () => this.get_opcion_no()
          }
        ]
      })
    }
    if(opcion==='finalizar_pedidov1'){
      this.setState({sub_modulo_modal:'previa'})
    }
  }
  salir_prefencias =()=>{
    this.setState({
      id_producto_combo:0,
      sub_modulo_modal:'',
      id_index:-1,
      precio_combo:0,
      sw_iva:0
    })
  }
  props_set_delete_preferencias=(uuid_transaccion)=>{
      let lista_items_adicional = this.state.lista_items_adicional
      let lista_items_adicional_temp =[]
      //console.log(lista_items_adicional)
      lista_items_adicional.forEach((cp,index) => {
        //if(Number(index_inicial)!==Number(index)){//if(Number(index_inicial)!==Number(index)){
        if(uuid_transaccion!==cp.uuid_transaccion){  
          lista_items_adicional_temp=[
            ...lista_items_adicional_temp,{
              'complemento_final': cp.complemento_final,
              'id_producto_combo': cp.id_producto_combo,
              'precio_adicional': cp.precio_adicional,
              'sw_iva': cp.sw_iva,
              'precio_inicial': cp.precio_inicial,
              'uuid_transaccion': cp.uuid_transaccion
            }
          ]
        }
      })
      this.setState({
        lista_items_adicional : lista_items_adicional_temp
      },()=>{
        this.total_pedido()
      })
  }

  editarCliente =()=>{
    this.setState({
      sub_modulo_modal:'cliente'
    })
  }
  getDataCliente =(id_cliente,nombre,token_Client)=>{
    //console.log(id_cliente+" "+nombre+" "+token_Client)
    this.setState({
      sub_modulo_modal:'',
      id_cliente,
      nombre,
      token_Client
    },()=>{
      this.get_List_Cliente()
    })
  }
  editarPreferencia =(id_producto_combo,index,precio_combo,sw_iva,uuid_transaccion)=>{
    this.setState({
      id_producto_combo:id_producto_combo,
      sub_modulo_modal:'combo',
      id_index:index,
      precio_combo,
      sw_iva,
      uuid_transaccion
    })
  }

  get_finalizar_pedido =(id_forma_pedido)=>{
    //base12, base0, iva12, total, id_estado_pedido, uuid_pedido, uuid_cliente, tiempo_estimado,
    // lat, lon,
    //const lista_items = this.props.lista_items
    const url= this.props.dir_url + "webapp/getNewPedido";
    const token =  this.props.token
    const token_Client =  this.state.token_Client
    const id_sucursal = this.state.id_sucursal
    const total_final = this.state.total_final
    const id_forma_pago =this.state.id_forma_pago
    const id_datos_facturacion =this.state.id_datos_facturacion
    const lista_items_adicional = this.state.lista_items_adicional
    const sw_llevar_validar = this.state.sw_llevar
    const sw_cubiertos_validar = this.state.sw_cubiertos
    let sw_llevar=0 
    let sw_cubiertos=0
    const observacion=this.state.observacion
    const lat = this.state.lat
    const lon = this.state.lon
    let detalle_pedido = []
    let costo_delivery= this.state.costo_delivery
    const items = this.state.lista_items
    const direccion_entrega = this.state.ubicacion
    const referencia_entrega = this.state.referencia_entrega
    const total_kilometros = this.state.total_kilometros
    const descuento =this.state.descuento
    const valor_efectivo = this.state.valor_pago_efectivo
    const uuid_agente =this.props.uuid_agente


    const database= this.props.database
    if(database!=='bd_app_5esquinas'&&database!=='bd_app_eldt'){ 
      if(id_forma_pago==0){
        if(valor_efectivo<=0){
          alert('Elija el valor en Billetes')
          return
        } 
      }
    }
    if(sw_llevar_validar){
      costo_delivery=0
      sw_llevar=1
    }
    if(sw_cubiertos_validar){
      sw_cubiertos=1
    }
    items.forEach (item => {
         item.Citems.forEach (ditem=> {
           if(this.state.items_cantidad[ditem.uuid_transaccion]){ //if(this.state.items_cantidad[ditem.id]){
              if(Number(this.state.items_cantidad[ditem.uuid_transaccion])>0){//if(Number(this.state.items_cantidad[ditem.id])>0){
               detalle_pedido=[...detalle_pedido, {
               	'cantidad': this.state.items_cantidad[ditem.uuid_transaccion],//'cantidad': this.state.items_cantidad[ditem.id],
               	'id_producto': ditem.id,
                 'observacion' : '',
                 'nota' : this.state.items_observaciones[ditem.uuid_transaccion],
                 'precio_neto' : ditem.precio_venta,
                 'iva': (Number(ditem.sw_iva)===1)?15:0,
                 'uuid_detalle':uuidv4()
               }]
             }
           }
         })
     })
     //console.log(lista_items_adicional)
     lista_items_adicional.forEach (item => {
       const uuid_detalle = uuidv4()
       detalle_pedido=[...detalle_pedido, {
         'cantidad': '1',
         'id_producto': item.id_producto_combo,
         'observacion' : JSON.stringify(item.complemento_final),
         'nota' : this.state.items_observaciones[item.uuid_transaccion],
         'precio_neto' : item.precio_inicial,
         'iva': (Number(item.sw_iva)===1)?15:0,
         'uuid_detalle': uuid_detalle
       }]
       item.complemento_final.forEach (comple => {


         if(comple.complemento==='Combo'){
           comple.CDetalle.forEach(cp_detalle_combo => {
             if(Number(cp_detalle_combo.cant)>0){
               detalle_pedido=[...detalle_pedido, {
                 'cantidad': cp_detalle_combo.cant,
                 'id_producto': cp_detalle_combo.id_productos,
                 'precio_neto' : cp_detalle_combo.precio,
                 'iva':0,
                 'uuid_pertenece': uuid_detalle,
                 'uuid_detalle': uuidv4()
               }]
             }
           })
         }
         if(comple.complemento==='Adicional'){
           if(Number(comple.cant)>0){
             detalle_pedido=[...detalle_pedido, {
               'cantidad': comple.cant,
               'id_producto': comple.id_productos,
               'precio_neto' : comple.precio,
               'iva': 0,
               'uuid_pertenece': uuid_detalle,
               'uuid_detalle': uuidv4()
             }]
           }
         }


       })
     })
    var obj = { accion:'nuevopedido',descuento,observacion, sw_llevar,token, token_Client,id_sucursal,total_final,id_forma_pago,id_datos_facturacion,lat,lon,
    costo_delivery,detalle_pedido,id_forma_pedido,lista_items_adicional,direccion_entrega,referencia_entrega,total_kilometros,sw_cubiertos,valor_efectivo,uuid_agente}
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.get_new_pedido_loading()
        this.get_new_despedida()
      }
    })
    .catch(console.log)
    this.get_loading(true)
  }

  
  get_new_despedida =()=>{
    confirmAlert({
      title: 'Mensaje de Cierre',
      message: (<div style={{ whiteSpace: "pre-wrap" }}>
        {this.state.script4}
      </div>),
      buttons: [
        {
          label: 'Finalizar Llamada',
          onClick: () => this.getCuelgaLLamada()
        }
      ],
      closeOnClickOutside: true, // permite que el modal se cierre al hacer clic fuera (por defecto ya está true)
      willUnmount: () => {
        console.log('Se cerró el modal'); // aquí puedes hacer lo que quieras
        this.getCuelgaLLamada(); // ejecutar tu función también al cerrar
      }
    })
  }
  get_new_pedido_loading =()=>{
    this.get_loading(false)
    this.props.regresar()
  }
  get_coordenadas =(lat,lon,ubicacion,id_ubicacion,referencia)=>{
    this.setState({
      lat,lon,ubicacion,id_ubicacion,referencia_entrega:referencia
    },()=>{
      this.getValorDelivery()
    })
  }

  getCuelgaLLamada =()=>{
    const url= this.props.dir_url + "webapp/getCuelgaLlamada";
    var obj = {usuario:this.props.usuario};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
       
    })
    .catch(console.log)

  }


  getValorDelivery =()=>{
    const url= this.props.dir_url + "webapp/getValorDelivery";
    const token =  this.props.token
    const token_Client =  this.state.token_Client
    const id_sucursal = this.state.id_sucursal
    const lat = this.state.lat
    const lon = this.state.lon
    var obj = { accion:'valordelivery', token, token_Client,id_sucursal,lat,lon};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        const costo_delivery = Number(data[0].msg[0].precio_delivery)
        if(data[0].msg[0].activo==='Inactivo'){
          alert("La Sucursal ("+data[0].msg[0].sucursales+") se encuentra Inactiva, verificar disponibilidad de la misma")
        }
        this.setState({sucursales_alternativas:data[0].msg,
          costo_delivery,id_sucursal:Number(data[0].msg[0].id_sucursales),horario:data[0].msg[0].horario
        }, ()=> this.getValueDelivery())
       // console.log(data[0])
      }else{
        this.setState({
          costo_delivery:0,id_sucursal:0
        }, ()=> this.getValueDelivery())
      }
    })
    .catch(console.log)

  }
  inputChangedHandler2 = (referencia_entrega)=>{
    this.setState({
      referencia_entrega
    })
  }
   inputChangedHandler3 = (observacion)=>{
    this.setState({
      observacion
    })
  }
  inputChangedHandler4= (sw_llevar)=>{
    this.setState({
      sw_llevar
    },()=>{
      this.total_pedido()
    })
  }
  inputChangedHandler5= (sw_cubiertos)=>{
    this.setState({
      sw_cubiertos
    },()=>{
      this.total_pedido()
    })
  }

  props_set_observacion =(items_observaciones)=>{
    this.setState(
      {items_observaciones}
    );
  }
  handleChanget = (event)=>{
    this.setState({
       id_sucursal: event.target.value
    },()=>this.getValueDelivery());
  }
  setIdSucursal =(id_sucursal)=>{
    this.setState({
      id_sucursal
    })
  }
  get_encerar_direccion=()=>{

  }
  retroceder =()=>{
    const id_sub_puntoventa_pantalla = this.state.id_sub_puntoventa_pantalla
    if(id_sub_puntoventa_pantalla==4)return
    this.setState(
      {
         ok_item : false
      } , () => {
          this.consultarItemAPIV2(id_sub_puntoventa_pantalla,1);
      }
    )
 }
 consultarItemAPIV2 =(id_sub_puntoventa_pantalla,accion)=>{
  //console.log("prueb")
  //const id_cuenta = this.state.id_cuenta;
  //console.log(id_subrubro);
  //const url= this.props.dir_url + "webapp/getCostoDelivery";
  const id_sucursal = this.state.id_sucursal
  const url= this.props.dir_url + "webapp/getItemsv2/"+id_sub_puntoventa_pantalla+"/"+accion+"/"+id_sucursal;
  //console.log(url);
    fetch(url)
    .then(res => res.json())
    .then((data) => {
     let dataList = [...data[0].data]; 
         let existingOrders = new Set(dataList.map(item => parseInt(item.orden)));
         let expectedOrders = new Set([...Array(42).keys()].map(i => i + 1));
         let missingOrders = [...expectedOrders].filter(order => !existingOrders.has(order));
         const createMissingEntry = (order) => ({
           id_item: null,
           item: null,
           precio_venta: null,
           iva: null,
           servicio: null,
           sw_incluido: null,
           id_rubro: null,
           id_subrubro: null,
           pfinal: null,
           id_combo: null,
           carga_maxima: null,
           id_puntoventa_pantalla: null,
           puntoventa_pantalla: null,
           sw_primaria: null,
           sw_cabecera: null,
           orden: order.toString(),
           puntoventa_lbl: null,
           id_sub_puntoventa_pantalla: null,
           color: null,
           tipo_funcion: null,
           activo: null,
           id_subaddicional: null,
           con_precio: null,
           precio_f: null
         });
         
         // Agregar los elementos faltantes
         missingOrders.forEach(order => {
           dataList.push(createMissingEntry(order));
         });

         dataList.sort((a, b) => parseInt(a.orden) - parseInt(b.orden));
         dataList = dataList.slice(0, 42);

      this.setState({ items: dataList , ok_item : true, id_sub_puntoventa_pantalla:data[0].id_tipo_pantalla})
    })
    .catch(console.log)
}
  render(){

    console.log(this.state.sucursales_alternativas)
    //console.log("NUM"+localStorage.getItem("numero"))
    if(this.state.sub_modulo_modal===''&&localStorage.getItem("numero")){
      localStorage.setItem("numero_temp",localStorage.getItem("numero"))
      localStorage.setItem("numero","")
      this.setState({
        sub_modulo_modal:"cliente"
      })
    }

    const items = this.state.items
    const total_items = this.state.total_items
    const total_final = this.state.total_final
    const id_cliente = this.state.id_cliente
    const sub_modulo_modal = this.state.sub_modulo_modal
    let dir_sub_modulo_modal
    if(sub_modulo_modal==='combo'){
      dir_sub_modulo_modal = <div id="loader_msg_sucursal" className="loader_msg_sucursal is-active" data-text="">
        <GetCombo sw_iva={this.state.sw_iva} precio_combo={this.state.precio_combo} lista_items_adicional={this.state.lista_items_adicional} id_index={this.state.id_index} agregarPreferencias={this.agregarPreferencias} salir_prefencias={this.salir_prefencias} id_producto_combo={this.state.id_producto_combo} uuid_transaccion={this.state.uuid_transaccion} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal}   props_set_data_items={this.props_set_data_items} props_set_cantidad={this.props_set_cantidad} lista_items={this.state.lista_items}  items_cantidad={this.state.items_cantidad} total_items={this.state.total_items} total_precio={this.state.total_precio} token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to} id_sucursal={this.state.id_sucursal} title={this.state.title} costo_delivery={this.state.costo_delivery} puntuacion={this.state.puntuacion} tiempo={this.state.tiempo} />
        </div>
    }
    if(sub_modulo_modal==='cliente'){
      dir_sub_modulo_modal = <div id="loader_msg_sucursal" className="loader_msg_sucursal is-active" data-text="">
                            <GetCCliente  getDataCliente={this.getDataCliente} token={this.props.token} dir_url={this.props.dir_url} getRegresar={this.getRegresar} />
                            </div>
    }
    
    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    const sucursales = this.state.sucursales

    let modalCambioSucursal = null;

    if (this.state.showCambioSucursal) {
      const alternativas = this.state.sucursales_alternativas.slice(1);

      modalCambioSucursal = (
        <div
          className="loader_msg_sucursal is-active"
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.35)',
            zIndex: 9999
          }}
        >
          <div
            className="modal_global"
            style={{
              width: '420px',
              padding: '20px',
              borderRadius: '8px',
              backgroundColor: '#fff',
              boxShadow: '0 10px 30px rgba(0,0,0,0.25)'
            }}
          >

            {/* HEADER */}
            <div
              style={{
                borderBottom: '1px solid #e0e0e0',
                paddingBottom: '10px',
                marginBottom: '15px'
              }}
            >
              <h3 style={{ margin: 0, fontSize: '18px' }}>
                Cambio de Sucursal
              </h3>
              <span style={{ fontSize: '12px', color: '#666' }}>
                Seleccione la nueva sucursal y justifique el cambio
              </span>
            </div>

            {/* SUCURSAL ALTERNATIVA */}
            <div style={{ marginBottom: '12px' }}>
              <label style={{ fontSize: '13px', fontWeight: 'bold' }}>
                Sucursal alternativa
              </label>
              <select
                className="select-css_global"
                style={{ marginTop: '5px' }}
                value={this.state.sucursal_alternativa_seleccionada}
                onChange={(e) =>
                  this.setState({ sucursal_alternativa_seleccionada: e.target.value })
                }
              >
                <option value="0">Seleccione Sucursal Alternativa</option>
                {alternativas.map(s => (
                  <option key={s.id_sucursales} value={s.id_sucursales}>
                    {s.sucursales}
                  </option>
                ))}
              </select>
            </div>

            {/* QUIÉN SOLICITA */}
            <div style={{ marginBottom: '12px' }}>
              <label style={{ fontSize: '13px', fontWeight: 'bold' }}>
                Quién solicita el cambio
              </label>
              <select
                className="select-css_global"
                style={{ marginTop: '5px' }}
                value={this.state.quien_solicita}
                onChange={(e) =>
                  this.setState({ quien_solicita: e.target.value })
                }
              >
                <option value="">Seleccione una opción</option>
                <option value="cliente">El cliente lo solicita</option>
                <option value="local">El local lo solicita</option>
              </select>
            </div>

            {/* OBSERVACIÓN */}
            <div style={{ marginBottom: '12px' }}>
              <label style={{ fontSize: '13px', fontWeight: 'bold' }}>
                Observación
              </label>
              <textarea
                className="textarea-css_global"
                style={{
                  marginTop: '5px',
                  minHeight: '70px',
                  resize: 'none'
                }}
                placeholder="Ingrese el motivo del cambio de sucursal"
                value={this.state.motivo_cambio}
                onChange={(e) =>
                  this.setState({ motivo_cambio: e.target.value })
                }
              />
            </div>

            {/* CONTRASEÑA */}
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontSize: '13px', fontWeight: 'bold' }}>
                Contraseña de autorización
              </label>
              <input
                type="password"
                className="input-css_global"
                style={{ marginTop: '5px' }}
                placeholder="Ingrese la contraseña"
                value={this.state.password_cambio_sucursal}
                onChange={(e) =>
                  this.setState({ password_cambio_sucursal: e.target.value })
                }
              />
            </div>

            {/* ACCIONES */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                borderTop: '1px solid #e0e0e0',
                paddingTop: '12px'
              }}
            >
              <button
                className="button-global"
                style={{
                  backgroundColor: '#ccc',
                  color: '#000'
                }}
                onClick={() =>
                  this.setState({ showCambioSucursal: false })
                }
              >
                Cancelar
              </button>

              <button
                className="button-global"
                style={{
                  backgroundColor: '#0a8f3c',
                  color: '#fff'
                }}
                onClick={this.confirmarCambioSucursal}
              >
                Confirmar cambio
              </button>
            </div>

          </div>
        </div>
      );
    }

    return(
      <React.Fragment>
      <div className="cssversion_menu cssversion_colorwhite" style={{"color":"black"}}>
        <div className="cssversion_pw100 cssversion_ph10 cssversion_colorblanco" style={{"display":"flex"}}>
          <div className="cssversion_pw10 cssversion_contentCenter" onClick={ () => this.props.regresar()}>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } />
          </div>
          <div className="cssversion_pw90 cssversion_contentCenter" >
            <select  className="select-css_global" value={this.state.id_sucursal} onChange={(e) => {this.handleChanget(e)}} disabled={(this.state.disabled)? "disabled" : ""}>
              <option value="0">Seleccione Sucursal</option>
              {(sucursales.length !== 0) ?
                sucursales.map(sucursal => (
                  <option key={sucursal.id_sucursales} value={sucursal.id_sucursales} >{sucursal.sucursales}</option>
                ))
                : <React.Fragment></React.Fragment>
              }
            </select>
            {Array.isArray(this.state.sucursales_alternativas) && this.state.sucursales_alternativas.length > 1 &&
              <button
                className="button-global"
                style={{ width: "160px", marginRight: "10px" }}
                onClick={this.abrirCambioSucursal}
              >
                Cambio de Sucursal
              </button>
            }
            <span style={{"width":"180px"}}>Horario {this.state.horario}</span>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_ph90" style={{"display":"flex"}}>
          <div className="cssversion_pxw250 cssversion_ph100 cssversion_inlinetable" >
            <GetCMenu
            database={this.props.database}
            descuento={this.state.descuento} 
            getDataVuelto ={this.getDataVuelto}
            inputChangedHandler2 ={this.inputChangedHandler2}
            inputChangedHandler3 ={this.inputChangedHandler3}
            inputChangedHandler4 ={this.inputChangedHandler4}
            inputChangedHandler5 ={this.inputChangedHandler5}
            referencia_entrega= {this.state.referencia_entrega}
            get_List_Cliente={this.get_List_Cliente}
            id_forma_pago ={this.state.id_forma_pago}
            forma_pago ={this.state.forma_pago}
            razon_social ={this.state.razon_social}
            ruc={this.state.ruc}
            sw_llevar={this.state.sw_llevar}
            sw_cubiertos={this.state.sw_cubiertos}
            observacion={this.state.observacion}
            telefono={this.state.telefono}
            direccion={this.state.direccion}
            email={this.state.email}
            id_datos_facturacion={this.state.id_datos_facturacion}
            alias={this.state.alias}
            ubicacion={this.state.ubicacion}
            nombre={this.state.nombre}
            id_ubicacion={this.state.id_ubicacion}
            lat={this.state.lat} lon={this.state.lon}
            token={this.props.token} dir_url={this.props.dir_url} token_Client={this.state.token_Client}
            id_cliente={this.state.id_cliente}
            editarCliente={this.editarCliente} costo_delivery={this.state.costo_delivery}
            valor_pago_efectivo ={this.state.valor_pago_efectivo}
             total_final={this.state.total_final} total_precio={this.state.total_precio} total_kilometros={this.state.total_kilometros} get_coordenadas={this.get_coordenadas}
             get_encerar_direccion={this.get_encerar_direccion}/>
          </div>

          <div className="cssversion_pxw400 cssversion_ph100 cssversion_inlinetable">
            <div className="cssversion_pw100 cssversion_ph80" style={{"overflowY":"auto"}}>
              <GetCNota props_set_observacion={this.props_set_observacion} items_observaciones={this.state.items_observaciones} editarPreferencia={this.editarPreferencia} props_set_delete_preferencias={this.props_set_delete_preferencias} props_set_cantidad={this.props_set_cantidad} lista_items_adicional={this.state.lista_items_adicional} items_cantidad={this.state.items_cantidad} lista_items={this.state.lista_items} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60} />
            </div>
            <div className="cssversion_pw100 cssversion_ph20">
              {(Number(total_items)>0&&Number(id_cliente)>0)?
              <div className="float_button_step_buy">

                {this.state.sub_modulo_modal===''?
                <button className="button-global" style={{"width":"250px"}} onClick={ () => this.get_go_to("finalizar_pedidov1")}>Continuar</button>
                :
                <button className="button-global" style={{"width":"250px"}} onClick={ () => this.get_go_to("finalizar_pedido")}>Pedir {total_items} por ${Number(total_final).toFixed(2)}</button>
                }
              </div>
              :''}
            </div>
          </div>


 
          {this.state.bd_base==='bd_app_lcr'?
                <React.Fragment> 
          <div className="cssversion_ph100 cssversion_inlinetable" style={{"width":"auto"}}>
            <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
            <div class="principal_itemv2">

              {(sub_modulo_modal==='previa')?
              <React.Fragment>
                <div className="cssversion_pw10 cssversion_contentCenter" onClick={ () => this.getRegresar()}>
                <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } />
                </div>
                <div style={{ whiteSpace: "pre-wrap" }}>
                  {this.state.script3}
                </div>
              </React.Fragment>
              :

              <React.Fragment>
                
                <div class="header_itemv2"><button className="boton_item_spanv2" onClick={ () => this.retroceder()}>Retroceder</button></div>
                <div class="grid-container_itemv2">
                <GetItemsv2 recuperar_item={this.additemv2} items={this.state.items} ok_item={this.state.ok_item} />
                </div>
                <div class="header_itemv3"> 
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    {this.state.script}
                  </div>
               </div>
               </React.Fragment>
              }

            </div>
            </div>
          </div>
         </React.Fragment>
:
               <React.Fragment>
                <div className="cssversion_pxw200 cssversion_ph100 cssversion_inlinetable">
                  <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
                    <GetCRubros rubros={this.state.rubros} getItems={this.getItems} />
                  </div>
                </div>
                <div className="cssversion_ph100 cssversion_inlinetable" style={{"width":"auto"}}>
                  <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
                    <div class="button-container">
                      {(items.length>0)?
                        <GetCItems additem={this.additem} items={this.state.items} />
                      :''}
                    </div>
                  </div>
                </div>
                
                </React.Fragment>}




        </div>
        {dir_sub_modulo_modal}
        {modal_loading}
        {modalCambioSucursal}
      </div>
      </React.Fragment>
    )
  }

confirmarCambioSucursal = async () => {
    const { sucursal_alternativa_seleccionada, motivo_cambio, quien_solicita ,password_cambio_sucursal } = this.state;

    if(
      Number(sucursal_alternativa_seleccionada) === 0 ||
      motivo_cambio.trim() === '' ||
      quien_solicita === ''
    ){
      alert('Debe seleccionar sucursal, quién solicita y una observación');
      return;
    }
    if (!this.state.password_cambio_sucursal) {
      alert('Debe ingresar la contraseña de autorización');
      return;
    }

    try{
      const url = this.props.dir_url + "webapp/validarcambio";
      const token = this.props.token;

      const obj = {
        accion:'validarcambio',
        token,
		token_Client:this.state.token_Client,
        id_sucursal_origen:this.state.id_sucursal,
        id_sucursal_destino:sucursal_alternativa_seleccionada,
        motivo:motivo_cambio,
        quien_solicita,
        password:password_cambio_sucursal
      };

     const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json(); // 👈 LEER RESPUESTA

      // Validación defensiva
      if (!Array.isArray(data) || !data[0]) {
        alert('Respuesta inválida del servidor');
        return;
      }

      const { status, msg } = data[0];

      if (status === 'ok') {
        alert(msg || 'Cambio de sucursal enviado correctamente');

        this.setState({
          id_sucursal: sucursal_alternativa_seleccionada,
          showCambioSucursal: false
        }, () => this.getValueDelivery());

      } else {
        // status === fail
        alert(msg && msg.trim() !== '' 
          ? msg 
          : 'No se pudo realizar el cambio de sucursal - Verifique la contraseña');
      }

      

    }catch(e){
      alert('Error al validar cambio de sucursal');
    }
  }
  /*
  
/*  <div className="cssversion_pxw200 cssversion_ph100 cssversion_inlinetable">
            <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
              <GetCRubros rubros={this.state.rubros} getItems={this.getItems} />
            </div>
          </div>
          <div className="cssversion_ph100 cssversion_inlinetable" style={{"width":"auto"}}>
            <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
              <div class="button-container">
                {(items.length>0)?
                  <GetCItems additem={this.additem} items={this.state.items} />
                :''}
              </div>
            </div>
          </div>

  /*

    <div style={{"backgroundColor":"white","height":"100%","color":"black","overflowY": "auto"}}>
    <div className="grid-container_call">
      <div className="lbl_call_menu">

        </div>
        <div className="lbl_call_pedido">
          <div className="lbl_call_detalle_pedido" style={{"display": "flex"}}>
            <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>

            </div>
          </div>
          <div className="lbl_call_totales">

          </div>
        </div>
        <div className="lbl_call_rubro" style={{"display": "flex"}}>
          <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>

          </div>
        </div>
        <div className="lbl_call_productos" style={{"display": "flex"}}>
          <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>

          </div>
        </div>


      </div>
    </div>*/

    abrirCambioSucursal = () => {
      this.setState({
        showCambioSucursal:true,
        sucursal_alternativa_seleccionada:0,
        motivo_cambio:'',
        quien_solicita:'',
		password_cambio_sucursal:''
      })
    }

    getDataVuelto =(valor_pago_efectivo)=>{
      //alert(valor_pago_efectivo)
       this.setState({
         valor_pago_efectivo
       })
     }
    getScript =()=>{
      const url= this.props.dir_url + "webapp/getScript";
      const token =  this.props.token
      var obj = { accion:'datascript', token,tipo:2 };
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        if(data[0].status==="ok"){
          this.setState({
            script :data[0].msg[0].script
          })
        }else{
          this.setState({
            script :""
          })
        }
      })
      .catch(console.log)
    }
    getScriptv3 =()=>{
      const url= this.props.dir_url + "webapp/getScript";
      const token =  this.props.token
      var obj = { accion:'datascript', token,tipo:3 };
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        if(data[0].status==="ok"){
          this.setState({
            script3 :data[0].msg[0].script
          })
        }else{
          this.setState({
            script3 :""
          })
        }
      })
      .catch(console.log)
    }
    getScriptv4 =()=>{
      const url= this.props.dir_url + "webapp/getScript";
      const token =  this.props.token
      var obj = { accion:'datascript', token,tipo:4 };
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        if(data[0].status==="ok"){
          this.setState({
            script4 :data[0].msg[0].script
          })
        }else{
          this.setState({
            script4 :""
          })
        }
      })
      .catch(console.log)
    }

    getValueDelivery =()=>{
      //const sw_validar_delivery = this.state.sw_validar_delivery
      //(sw_validar_delivery!==1)return
      const url= this.props.dir_url + "webapp/getCostoDelivery";
      const token =  this.props.token
      const lat = this.state.lat
      const lon = this.state.lon
      const id_sucursal = this.state.id_sucursal
      //console.log(id_sucursal)
      var obj = { accion:'getcostodelivery', token, lat, lon  ,id_sucursal};
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(obj),
        headers:{
          'Accept':'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(res => res.json())
      .then((data) => {
        //console.log(data)
        if(data[0].status==="ok"){
          let kilometro_actual =0
          let costo_delivery =0
 
          //const total = Number(this.state.total)

          if(data[0].base==="bd_app_lcr"){
            //console.log("dia")
            kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;
            costo_delivery = 2.50
            if(kilometro_actual > 4){
              costo_delivery = costo_delivery + Math.ceil(kilometro_actual-1)*0.4
            }//
            
            
          }else{
            if(data[0].base==="bd_app_5esquinas"){
                kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;

                //kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;
                /*if(kilometro_actual<=5){
                  costo_delivery =2.1
                }else if(kilometro_actual<=5.4) {
                  costo_delivery =2.1
                }else if(kilometro_actual<=6.4){
                  costo_delivery =2.5
                }else if(kilometro_actual<=7.4){
                  costo_delivery =2.85
                }else if(kilometro_actual<=8.4){
                  costo_delivery =3.2
                }else if(kilometro_actual<=9.4){
                  costo_delivery =3.55
                }else if(kilometro_actual<=10.4){
                  costo_delivery =3.90
                }else if(kilometro_actual<=11.4){
                  costo_delivery =4.25
                }else if(kilometro_actual<=12.4){
                  costo_delivery =4.6
                }else if(kilometro_actual<=13.4){
                  costo_delivery =4.95
                }else if(kilometro_actual<=14.4){
                  costo_delivery =5.3
                }else if(kilometro_actual<=15.4){
                  costo_delivery =5.65
                }else if(kilometro_actual<=16.4){
                  costo_delivery =6
                }else if(kilometro_actual<=17.4){
                  costo_delivery =6.35
                }else if(kilometro_actual<=18.4){
                  costo_delivery =6.7
                }else if(kilometro_actual<=19.4){
                  costo_delivery =7.05
                }else if(kilometro_actual<=20.4){
                  costo_delivery =7.4
                }else if(kilometro_actual<=21.4){
                  costo_delivery =7.75
                }else if(kilometro_actual<=22.4){
                  costo_delivery =8.1
                }else if(kilometro_actual<=23.4){
                  costo_delivery =8.45
                }else if(kilometro_actual<=24.4){
                  costo_delivery =8.8
                }else if(kilometro_actual<=25.4){
                  costo_delivery =9.15
                }*/
                if(kilometro_actual<=5){
                    costo_delivery = 2.4
                }else if(kilometro_actual<=6){
                    costo_delivery = 2.9
                }else if(kilometro_actual<=7){
                    costo_delivery = 3.3
                }else if(kilometro_actual<=8){
                    costo_delivery = 3.7
                }else if(kilometro_actual<=9){
                    costo_delivery = 4.1
                }else if(kilometro_actual<=10){
                    costo_delivery = 4.5
                }else if(kilometro_actual<=11){
                    costo_delivery = 4.9
                }else if(kilometro_actual<=12){
                    costo_delivery = 5.3
                }else if(kilometro_actual<=13){
                    costo_delivery = 5.7
                }else if(kilometro_actual<=14){
                    costo_delivery = 6.1
                }else if(kilometro_actual<=15){
                    costo_delivery = 6.5
                }else if(kilometro_actual<=16){
                    costo_delivery = 6.9
                }else if(kilometro_actual<=17){
                    costo_delivery = 7.3
                }else if(kilometro_actual<=18){
                    costo_delivery = 7.7
                }else if(kilometro_actual<=19){
                    costo_delivery = 8.1
                }else if(kilometro_actual<=20){
                    costo_delivery = 8.5
                }else if(kilometro_actual<=21){
                    costo_delivery = 8.9
                }else if(kilometro_actual<=22){
                    costo_delivery = 9.3
                }else if(kilometro_actual<=23){
                    costo_delivery = 9.7
                }else if(kilometro_actual<=24){
                    costo_delivery = 10.1
                }else if(kilometro_actual<=25){
                    costo_delivery = 10.5
                }else if(kilometro_actual<=26){
                    costo_delivery = 10.9
                }else if(kilometro_actual<=27){
                    costo_delivery = 11.3
                }else if(kilometro_actual<=28){
                    costo_delivery = 11.7
                }else if(kilometro_actual<=29){
                    costo_delivery = 12.1
                }else if(kilometro_actual<=30){
                    costo_delivery = 12.5
                }
            }else{
              if(data[0].base==="bd_app_eldt"){
                 kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;

                //let costo_delivery =0
                if (kilometro_actual <= 1.64) {
                  costo_delivery = 1.65;
                } else if (kilometro_actual <= 5.04) {
                  costo_delivery = 2.15;
                } else if (kilometro_actual <= 6.04) {
                  costo_delivery = 2.70;
                } else if (kilometro_actual <= 7.04) {
                  costo_delivery = 3.25;
                } else if (kilometro_actual <= 8.04) {
                  costo_delivery = 3.80;
                } else if (kilometro_actual <= 9.04) {
                  costo_delivery = 4.30;
                } else if (kilometro_actual <= 10.04) {
                  costo_delivery = 4.80;
                } else if (kilometro_actual <= 11.04) {
                  costo_delivery = 5.30;
                } else if (kilometro_actual <= 12.04) {
                  costo_delivery = 5.85;
                } else if (kilometro_actual <= 13.04) {
                  costo_delivery = 6.35;
                } else if (kilometro_actual <= 14.04) {
                  costo_delivery = 6.85;
                } else if (kilometro_actual <= 15.04) {
                  costo_delivery = 7.40;
                } else if (kilometro_actual <= 16.04) {
                  costo_delivery = 7.90;
                } else if (kilometro_actual <= 17.04) {
                  costo_delivery = 8.40;
                } else if (kilometro_actual <= 18.04) {
                  costo_delivery = 8.95;
                } else if (kilometro_actual <= 19.04) {
                  costo_delivery = 9.45;
                } else if (kilometro_actual <= 20.04) {
                  costo_delivery = 10.00;
                } else if (kilometro_actual <= 21.04) {
                  costo_delivery = 10.50;
                } else if (kilometro_actual <= 22.04) {
                  costo_delivery = 11.00;
                } else if (kilometro_actual <= 23.04) {
                  costo_delivery = 11.50;
                } else if (kilometro_actual <= 24.04) {
                  costo_delivery = 12.05;
                } else if (kilometro_actual <= 25.04) {
                  costo_delivery = 12.55;
                } else if (kilometro_actual <= 26.04) {
                  costo_delivery = 13.05;
                } else if (kilometro_actual <= 27.04) {
                  costo_delivery = 13.60;
                } else if (kilometro_actual <= 28.04) {
                  costo_delivery = 14.10;
                } else if (kilometro_actual <= 29.04) {
                  costo_delivery = 14.65;
                } else if (kilometro_actual <= 30.04) {
                  costo_delivery = 15.15;
                }
              }else{
                kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;
                if(kilometro_actual<=1.4){
                  costo_delivery =1.8
                }else if(kilometro_actual<=5.4) {
                  costo_delivery =2.1
                }else if(kilometro_actual<=6.4){
                  costo_delivery =2.5
                }else if(kilometro_actual<=7.4){
                  costo_delivery =2.85
                }else if(kilometro_actual<=8.4){
                  costo_delivery =3.2
                }else if(kilometro_actual<=9.4){
                  costo_delivery =3.55
                }else if(kilometro_actual<=10.4){
                  costo_delivery =3.90
                }else if(kilometro_actual<=11.4){
                  costo_delivery =4.25
                }else if(kilometro_actual<=12.4){
                  costo_delivery =4.6
                }else if(kilometro_actual<=13.4){
                  costo_delivery =4.95
                }else if(kilometro_actual<=14.4){
                  costo_delivery =5.3
                }else if(kilometro_actual<=15.4){
                  costo_delivery =5.65
                }else if(kilometro_actual<=16.4){
                  costo_delivery =6
                }else if(kilometro_actual<=17.4){
                  costo_delivery =6.35
                }else if(kilometro_actual<=18.4){
                  costo_delivery =6.7
                }else if(kilometro_actual<=19.4){
                  costo_delivery =7.05
                }else if(kilometro_actual<=20.4){
                  costo_delivery =7.4
                }else if(kilometro_actual<=21.4){
                  costo_delivery =7.75
                }else if(kilometro_actual<=22.4){
                  costo_delivery =8.1
                }else if(kilometro_actual<=23.4){
                  costo_delivery =8.45
                }else if(kilometro_actual<=24.4){
                  costo_delivery =8.8
                }else if(kilometro_actual<=25.4){
                  costo_delivery =9.15
                }
              }
          }
        }



          this.setState({
            total_kilometros:kilometro_actual,
            costo_delivery 
          },()=>this.total_pedido())


        }else{
          this.total_pedido()
        }
      })
      .catch(console.log)
    }
  async componentDidMount (){
    await this.getSucursales()
    this.getRubros()
    this.consultarItemAPIV2(4,0)
    this.getScript()
    this.getScriptv3()
    this.getScriptv4()
  }

}
export default getContenedorFacturacion;
